import features from '../../../shared/features'

export function scrollWatcher(callback: (scrollPercent: number) => void) {
  const doc = document.documentElement
  const onScroll = () => {
    const height = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      doc.scrollHeight,
      doc.offsetHeight,
      doc.clientHeight
    )
    const scrollPercent =
      (((window.pageYOffset || doc.scrollTop) +
        (window.innerHeight || doc.clientHeight)) /
        height) *
      100
    callback(Math.round(scrollPercent))
  }

  window.addEventListener(
    'scroll',
    onScroll,
    features().events.passiveSupported
      ? { passive: true, capture: false }
      : true
  )

  window.addEventListener('onload', () => onScroll())
}
